import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    Button,
    TextField,
    InputLabel,
    IconButton,
    Typography
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import routes from "../../react_routes_enum";
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import DialogContent from "@mui/material/DialogContent";
import { useNavigate } from "react-router-dom";
import UserTable from "../../components/BasicTable/BasicTable";
import Spinner from "../../components/Spinner/Spinner";
import Pagination from "../../components/Pagination/Pagination";
import { getContactUs, deleteContactUs } from "../../redux/students/studentsSlice";
import VisibilityIcon from '@mui/icons-material/Visibility';

const ContactUs = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [page, setPage] = useState(0);
    const [contactInfo, setContactInfo] = useState({});
    const [contactUsId, setContactUsId] = useState("");
    const [userListView, setUserListView] = useState(true);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const {
        isError,
        message,
        isLoading,
        totalCount,
        contactUsData } = useSelector((state) => state.students)

    const columns = [
        "SNo",
        "name",
        "phone",
        "email",
        "Action",
    ];

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    const deleteClicked = (id) => {
        const res = dispatch(deleteContactUs(id));
        res?.then((r) => {
            if(r.payload.statusCode === 200){
                setIsDialogOpen(false);
                toast.success("Record Deleted Successfully");
                dispatch(getContactUs({ limit, offset }));
                return;
            }
            if (r.payload.message === "unauthorized" ||
                r.payload.message === "Unauthorized" ||
                r.payload.message === "Session Expired") {
                setIsDialogOpen(false);
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                navigate(routes.LOGIN);
                return;
            }
            toast.error(r?.payload || r?.payload?.message);
        })
    }

    useEffect(() => {
        const res = dispatch(getContactUs({ limit, offset }));
        res?.then((r) => {
            if (r.payload.message === "unauthorized" ||
                r.payload.message === "Unauthorized" ||
                r.payload.message === "Session Expired") {
                toast.error("Session expired, please login again");
                localStorage.removeItem("hp_token");
                localStorage.removeItem("hp_user");
                navigate(routes.LOGIN);
            }
        })
    }, [limit, offset]);

    if (isLoading) return <Spinner />;

    if (isError) return <h1 style={{ color: "red" }}>{message}</h1>;

    return (
        <div style={{
            marginTop: '5%'
        }}>
            <Dialog maxWidth="sm" open={isDialogOpen} onClose={handleClose} fullWidth>
                {contactUsId ?
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                marginTop: '24px',
                                justifyContent: 'center'
                            }}
                        >
                            <DeleteIcon
                                sx={{
                                    fontSize: '64px',
                                    color: '#EF0000'
                                }}
                            />
                        </div>
                        <Typography component="p" variant="p"
                            sx={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                margin: '16px 0 48px'
                            }}>
                            Are you sure you want to<br /> you want to delete this record
                        </Typography>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'row-reverse',
                            padding: '0px 16px 28px 16px'
                        }}>
                            <Button onClick={() => { setIsDialogOpen(false) }} variant="outlined" sx={{
                                textTransform: 'capitalize'
                            }}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => { deleteClicked(contactUsId) }}
                                variant="contained"
                                sx={{
                                    width: '84px',
                                    marginRight: '12px',
                                    textTransform: 'capitalize',
                                    backgroundColor: 'var(--primary-color)',
                                }}
                            >
                                Yes
                            </Button>
                        </div>
                    </div> :
                    <form style={{ padding: '0 5% 2% 5%' }}>
                        <DialogContent>
                            <h3 style={{
                                fontSize: '28px',
                                textAlign: 'center',
                                marginBottom: '0px'
                            }}>
                                Detail
                            </h3>
                            <div style={{
                                height: '20px',
                                width: '100%'
                            }}></div>
                            {contactInfo?.name &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Name
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.name}
                                            type="text"
                                            name="name"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.email &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Email
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.email}
                                            type="email"
                                            name="email"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.phone &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Phone Number
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.phone}
                                            type="number"
                                            name="phone"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.message &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Message
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.message}
                                            type="text"
                                            name="phone"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.neet_score &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Neet Score
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.neet_score}
                                            type="neet_score"
                                            name="neet_score"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.prefered_country &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Prefered Country
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.prefered_country}
                                            type="prefered_country"
                                            name="prefered_country"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.country &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Country
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            type="country"
                                            name="country"
                                            variant="outlined"
                                            value={contactInfo?.country}
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.company_name &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Company Name
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.company_name}
                                            type="text"
                                            name="phone"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.company_website &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Company Website
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.company_website}
                                            type="text"
                                            name="phone"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.office_location &&
                                <>
                                    <div>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>
                                            Company Location
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            value={contactInfo?.office_location}
                                            type="text"
                                            name="phone"
                                            variant="outlined"
                                            required />
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                            {contactInfo?.id_proof &&
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <InputLabel sx={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            marginBottom: '4px'
                                        }}>
                                            Download Firm Document:
                                        </InputLabel>
                                        <a href={contactInfo?.firm_document} target="_blank">
                                            <DownloadIcon sx={{ color: '#000' }} />
                                        </a>
                                    </div>
                                    <div style={{ width: '100%', height: '16px' }}></div>
                                </>
                            }
                        </DialogContent>
                    </form>}
            </Dialog>
            {userListView && (
                <>
                    {/* <SearchTextField
                    searchText={searchText}
                    handleSearchText={handleSearchText}
                    fromWhere="subscribedUsers"
                /> */}
                    <Pagination
                        totalCount={totalCount}
                        limit={limit}
                        page={page}
                        changeLimit={setLimit}
                        changeOffset={setOffset}
                        changePage={setPage}
                    />
                    <UserTable
                        columns={columns}
                        rows={
                            contactUsData &&
                            contactUsData?.map((item) => {
                                const res = {
                                    ...item,
                                    Action: (
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <IconButton
                                                color="inherit"
                                                edge="start"
                                                sx={{
                                                    display: 'flex',
                                                    marginRight: '8px',
                                                    flexDirection: 'column',
                                                }}
                                                onClick={() => {
                                                    setContactUsId("")
                                                    setIsDialogOpen(true)
                                                    setContactInfo(item)
                                                }}>
                                                <VisibilityIcon sx={{ color: '#3C1CDE' }} />
                                                <Typography component="p" variant="p"
                                                    sx={{
                                                        color: '#3C1CDE',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        marginTop: '5px'
                                                    }}>
                                                    View
                                                </Typography>
                                            </IconButton>
                                            <IconButton
                                                color="inherit"
                                                edge="start"
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}
                                                onClick={() => {
                                                    setIsDialogOpen(true);
                                                    setContactUsId(item._id);
                                                }}
                                            >
                                                <DeleteIcon sx={{ color: '#EF0000' }} />
                                                <Typography component="p" variant="p"
                                                    sx={{
                                                        color: '#EF0000',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        marginTop: '6px'
                                                    }}>
                                                    Delete
                                                </Typography>
                                            </IconButton>
                                        </div>
                                    )
                                };
                                return res;
                            })
                        }
                    />
                </>
            )}
        </div>
    );
};

export default ContactUs;
